import Tab from '@mui/material/Tab'
import React, {FC, MutableRefObject, useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {
  GetActivityCountersRequests,
  useFilterNotificationsList,
  GetNotifications,
  NotificationTypesList,
  setFilterNotifications,
  useNotificationsCursor,
  useNotificationsFilteredList,
  useNotificationsCounters,
  setNotificationsCounters,
  NotificationKeysTypes
} from 'entities/activity'
import {NotificationItem} from 'features/notificationItem'
import {useVirtualScroll} from 'shared/hooks'
import {Loader} from 'shared/ui/loader'
import {Tabs} from 'shared/ui/tabs'
import styles from './styles.module.scss'

export const NotificationsPage: FC<{wrapperRef: MutableRefObject<HTMLDivElement | null>}> = ({wrapperRef}) => {
  const dispatch = useDispatch()
  const cursor = useNotificationsCursor()
  const {refetch: load, isFetching, isError} = GetNotifications(dispatch)

  useVirtualScroll({ref: wrapperRef, cursor, load, isFetching, isError})

  return (
    <Notifications isFetching={isFetching} />
  )
}

type NotificationsProps = {
  isFetching: boolean
}

const Notifications: FC<NotificationsProps> = ({isFetching}) => {
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState<NotificationKeysTypes>(useFilterNotificationsList())
  const list = useNotificationsFilteredList()
  const counters = useNotificationsCounters()

  useEffect(() => {
    GetActivityCountersRequests().then(({data}) => dispatch(setNotificationsCounters({
      ...data,
      all: data.like + data.match + data.favorite + data.visit + data.possible_match,
      allMatch: data.match + data.possible_match
    })))
  }, [])

  return (
    <>
      <div className={styles.contentContainer}>
        <Tabs
          className={styles.tabs}
          value={activeTab}
          onChange={(_, id: NotificationKeysTypes) => {
            setActiveTab(id)
            dispatch(setFilterNotifications(id))
          }}
          variant='scrollable'
        >
          {NotificationTypesList.map(({id, label}) =>
            <Tab
              key={id}
              value={id}
              label={
                <div className={styles.tab}>
                  <div className={styles.text}>{label}</div>
                  {counters ? <div className={styles.count}>{counters[id]}</div> : null}
                </div>
              }
            />
          )}
        </Tabs>
        <div className={styles.notificationsList}>
          {list.map((notification) =>
            <NotificationItem notification={notification} isAction={true} key={notification.id} />)}
        </div>
        {isFetching ? <div className={styles.loader}><Loader /></div> : null}
      </div>
      <div className={styles.bottom} />
    </>
  )
}